export default __webpack_public_path__ + "static/logo-9-b903d0e049570c27efe28c2a24381cc6.webp";